import React from 'react';
import { toast } from 'react-toastify';

class ConnectionToastManager {
  constructor() {
    this.hasActiveToast = false;
    this.hadConnectionProblem = false;
    this.debounceTimer = null;
  }

  showConnectionStatus(status) {
    clearTimeout(this.debounceTimer);

    switch (status) {
      case 'connecting': {
        // Показываем только если подключение затягивается (>2 сек)
        this.debounceTimer = setTimeout(() => {
          this.hasActiveToast = true;
          toast.info(
            <div>
              <i className="la la-spinner la-spin" style={{ marginRight: '8px' }}></i>
              <span>Подключение...</span>
            </div>,
            {
              toastId: 'connection-status',
              autoClose: false,
              closeButton: false
            }
          );
        }, 2000);
        break;
      }

      case 'error': {
        this.hasActiveToast = true;
        this.hadConnectionProblem = true;
        toast.error(
          <div>
            <i className="la la-exclamation-triangle" style={{ marginRight: '8px' }}></i>
            <span>Ошибка подключения</span>
          </div>,
          {
            toastId: 'connection-status',
            autoClose: false,
            closeButton: true
          }
        );
        break;
      }

      case 'disconnected': {
        this.hadConnectionProblem = true;
        // Показываем только если отключение длится >3 сек (избегаем мигания при reconnect)
        this.debounceTimer = setTimeout(() => {
          this.hasActiveToast = true;
          toast.warn(
            <div>
              <i className="la la-unlink" style={{ marginRight: '8px' }}></i>
              <span>Отключено</span>
            </div>,
            {
              toastId: 'connection-status',
              autoClose: false,
              closeButton: false
            }
          );
        }, 3000);
        break;
      }

      case 'connected': {
        toast.dismiss('connection-status');

        if (this.hadConnectionProblem) {
          toast.success(
            <div>
              <i className="la la-check-circle" style={{ marginRight: '8px' }}></i>
              <span>Подключено</span>
            </div>,
            {
              toastId: 'connection-success',
              autoClose: 3000,
              closeButton: false
            }
          );
        }

        this.hasActiveToast = false;
        this.hadConnectionProblem = false;
        break;
      }

      default:
        console.warn('[ConnectionToastManager] Unknown status:', status);
    }
  }

  reset() {
    clearTimeout(this.debounceTimer);
    toast.dismiss('connection-status');
    toast.dismiss('connection-success');
    this.hasActiveToast = false;
    this.hadConnectionProblem = false;
  }
}

const connectionToastManager = new ConnectionToastManager();
export default connectionToastManager;
